import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { DELIVERY_METHODS } from "constant/action-constants";
import { RootState } from "interfaces/generics.type";
import BOPISToolTip from "modules/bopis/BOPISToolTip";
import MessageCard from "modules/components/message-card/MessageCard";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import qs from "query-string";
import { useSelector } from "react-redux";
import { compactShippingFee } from "util/helper/compactShippingFee";
import { getDeliveryMethodDetails } from "util/helper/getDeliveryMethodDetails";
import { isCheckoutPages, isShoppingCartPage } from "util/url/checkRouteInclude";
import DeliveryCounter from "../delivery-counter/DeliveryCounter";
import { minimumShippingCost } from "../helper/minimumShippingCost";
import { selectedDeliveryMethodDetails } from "../helper/selectedDeliveryMethodDetails";
import styles from "./deliveryShippingInfo.module.scss";

interface IProps {
  deliveryMethod: string;
  availableDeliveryMethodsDetails?: any;
}

export function PickupShippingInfo(props: IProps) {
  const { deliveryMethod, availableDeliveryMethodsDetails } = props;
  const { t } = useTranslation(["shopping-cart", "common"]);
  const userCart = useSelector((store: RootState) => store.shoppingCart);
  const router = useRouter();
  const selectedDeliveryMethod = selectedDeliveryMethodDetails(deliveryMethod, availableDeliveryMethodsDetails);

  if (!selectedDeliveryMethod) {
    return null;
  }

  if (deliveryMethod === DELIVERY_METHODS.PICKUP) {
    return (
      <div className={(isCheckoutPages(router.pathname, router.query) || isShoppingCartPage(router.pathname))
        ? styles.each_method_container_shopping_cart : styles.each_method_container_product_page}
      >
        <MessageCard
          message={(
            <>
              <span>{`${t("Pick up at")} `}</span>
              {/* http://localhost:3000/raybestos-front-ceramic-pads-mgd914ch?store=mississauga */}
              <PAText fontSize={FONT_SIZE[0]} underline>
                {qs.parse(location.search).store ? <BOPISToolTip /> : userCart?.pickUpLocations?.[0]?.name}
              </PAText>
            </>
          )}
          subtext={t("pickup_notification_message_2")}
          type="info"
        />
      </div>
    );
  }
  return null;
}

export function RapidDeliveryInfo(props: IProps) {
  const { deliveryMethod, availableDeliveryMethodsDetails } = props;
  const { t } = useTranslation(["shopping-cart", "common"]);
  const router = useRouter();
  const { locale, pathname } = router;
  const { deliveryDetails } = getDeliveryMethodDetails(availableDeliveryMethodsDetails) || {};
  const selectedDeliveryMethod = selectedDeliveryMethodDetails(deliveryMethod, availableDeliveryMethodsDetails);

  if (!selectedDeliveryMethod) {
    return null;
  }

  if (deliveryMethod === DELIVERY_METHODS.DELIVERY) {
    return (
      <div className={(isCheckoutPages(router.pathname, router.query) || isShoppingCartPage(router.pathname))
        ? styles.each_method_container_shopping_cart : styles.each_method_container_product_page}
      >
        <MessageCard
          message={deliveryDetails?.deliveryCost ? (
            <>
              {`${t("Free Rapid Local Delivery Over")}
            ${compactShippingFee(minimumShippingCost(DELIVERY_METHODS.DELIVERY, availableDeliveryMethodsDetails, locale), pathname)} `}
            </>
          ) : `${t("Free Rapid Local Delivery")}`}
          subtext={(
            <DeliveryCounter
              deliveryMethod={deliveryMethod}
              availableDeliveryMethodsDetails={availableDeliveryMethodsDetails}
            />
          )}
          type="info"
        />
      </div>
    );
  }

  return null;
}

export function ShippingDeliveryInfo(props: IProps) {
  const { deliveryMethod, component, availableDeliveryMethodsDetails } = props;
  const { t } = useTranslation(["shopping-cart", "common"]);
  const router = useRouter();
  const { locale, pathname } = router;
  const { shipmentDetails } = getDeliveryMethodDetails(availableDeliveryMethodsDetails) || {};
  const selectedDeliveryMethod = selectedDeliveryMethodDetails(deliveryMethod, availableDeliveryMethodsDetails);

  if (!selectedDeliveryMethod) {
    return null;
  }

  if (deliveryMethod === DELIVERY_METHODS.SHIPPING) {
    return (
      <div className={(isCheckoutPages(router.pathname, router.query) || isShoppingCartPage(router.pathname))
        ? styles.each_method_container_shopping_cart : styles.each_method_container_product_page}
      >
        <MessageCard
          message={(
            <>
              {shipmentDetails?.baseShipmentCost
                ? `${t("Fast & Free Shipping Over")} ${compactShippingFee(minimumShippingCost(DELIVERY_METHODS.SHIPPING, availableDeliveryMethodsDetails, locale), pathname)} `
                : `${t("Fast & Free Shipping")} `}
            </>
          )}
          subtext={(
            <>
              {shipmentDetails?.baseShipmentCost ? t("Small shipping fee otherwise") : ""}
              <DeliveryCounter
                deliveryMethod={deliveryMethod}
                availableDeliveryMethodsDetails={availableDeliveryMethodsDetails}
              />
            </>
          )}
          type="info"
        />
        <div style={{ marginLeft: "calc(3.68 * var(--safari-root-font, 10px))" }}>
          {component}
        </div>
      </div>
    );
  }
  return null;
}
